<template>
  <div class="content1" :class="sty ? '' : 'border-no'" v-click-outside="clickOutSide">
    <div class="title flex-y-center" @click="opt">
      <div class="txt" v-if="item[keyword]">{{ item.name }}</div>
      <span v-else>{{ holder || '请选择' }}</span>
      <div class="opt flex-center" :class="sty ? '':'border-no'">
        <div class="icon" :class="state? 'rotate' : ''"></div>
      </div>
    </div>
    <div v-show="state" class="list select-box">
      <div v-for="(i,index) in list" :key="index" class="item flex-y-center"
        :class="i[keyword] == item[keyword]? 't-ac' : '' " @click="selEvent(index)">{{ i.name }}</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      list: {
        type: Array,
      },
      item: {
        type: Object,
        default: function() {
          return {}
        }
      },
      keyword: {
        type: String,
        default: 'value'
      },
      holder: {
        type: String
      },
      sty: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        state: false
      }
    },
    methods: {
      opt() {
        this.state = !this.state;
      },
      selEvent(idx) {
        const target = this.list[idx];
        if(target[this.keyword] != this.item[this.keyword]){
          this.$emit("sel", target);
          this.state = false;
        };
      },
      clickOutSide() {
        this.state = false;
      }
    }
  }
</script>
<style scoped lang="less">
  .content1 {
    position: relative;
    width: 100%;
    height: 32px;
    border: 1px solid #48546C;
    cursor: pointer;
    .title {
      width: 100%;
      height: 32px;
      font-size: 13px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      padding-left: 12px;
      .txt {
        width: calc(100% - 34px);
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
      .opt {
        width: 32px;
        height: 32px;
        margin-left: auto;
        border-left: 1px solid #48546C;
        .icon {
          width: 0;
          height: 0;
          border: 6px solid;
          margin-top: 6px;
          border-color: #ffffff transparent transparent transparent;
        }
        .rotate {
          transform: rotate(180deg);
          margin-top: -6px;
        }
      }
    }
    .list {
      position: absolute;
      left: 0;
      bottom: -200px;
      z-index: 1001;
      width: 100%;
      height: 192px;
      background: #ffffff;
      overflow-y: scroll;
      overflow-x: hidden;
      .item {
        width: 100%;
        padding: 10px 0 10px 12px;
        font-size: 13px;
        font-weight: 400;
        color: #000E2B;
        cursor: pointer;
        word-break: break-all;
        word-wrap: break-word;
      }
      .item:hover {
        background: rgba(40, 136, 241, .14);
      }
      .t-ac {
        background: rgba(40, 136, 241, .14);
      }
    }
  }
  .border-no {
    border-color: transparent !important;
  }
</style>